import { AxiosResponse } from 'axios';
import api from './api';

export interface WorkOrder {
  id: string;
  description: string;
  status: string;
  reportDate: Date;
  workType: string;
  priority: number;
  location?: string;
  assignedTeam?: string;
  wonum: string
}

export interface Team {
  id: string;
  name: string;
  workOrderCount?: number;
}

export interface AssignWorkOrderRequest {
  workOrderId: string;
  teamId: string;
}

export interface GetTeamWorkOrdersParams {
  limit?: number;
  date?: string;
}

export interface GetUnassignedWorkOrdersParams {
  page?: number;
  limit?: number;
  search?: string;
  priority?: number;
  workType?: string;
}

export interface PaginatedWorkOrderResponse {
  data: WorkOrder[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}


export interface CreateWorkOrderRequest {
  id: string;
  description: string;
  priority: number;
  workType: string;
  location?: string;
  reportDate: string;
  status: string;
  assignedTeam?: string;
}

export const maximoApi = {
  // Get unassigned work orders with pagination and search
  getUnassignedWorkOrders: (params?: GetUnassignedWorkOrdersParams): Promise<AxiosResponse<PaginatedWorkOrderResponse>> => {
    return api.get('/maximo/workorders/unassigned', { params });
  },

  // Get all teams
  getTeams: (): Promise<AxiosResponse<Team[]>> => {
    return api.get('/maximo/teams');
  },

  // Assign work order to team
  assignWorkOrder: (data: AssignWorkOrderRequest): Promise<AxiosResponse<{ message: string }>> => {
    return api.post('/maximo/workorders/assign', data);
  },

  // Get work orders for a specific team
  getTeamWorkOrders: (
    teamId: string, 
    params?: GetTeamWorkOrdersParams
  ): Promise<AxiosResponse<WorkOrder[]>> => {
    return api.get(`/maximo/teams/${teamId}/workorders`, { params });
  },


  // Create new work order
  createWorkOrder: (data: CreateWorkOrderRequest): Promise<AxiosResponse<{ message: string; workOrder: WorkOrder }>> => {
    return api.post('/maximo/workorders', data);
  },

  // Unassign work order
  unassignWorkOrder: (data: { workOrderId: string }): Promise<AxiosResponse<{ message: string }>> => {
    return api.post('/maximo/workorders/unassign', data);
  },

};